import { render, staticRenderFns } from "./Traitement.vue?vue&type=template&id=214bfdf3"
import script from "./Traitement.vue?vue&type=script&lang=js"
export * from "./Traitement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports